import React, { Component } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Link,
  Switch
} from 'react-router-dom';


import SideBar from './sidebar.js';
import TopBar from './topbar.js';
import Dashboard from './dashboard.js';
import Apps from './apps.js';
import Docs from './docs.js';
import AppCreator from './appsCreator.js';
import Billing from './billing.js';
import MDDocs from './MDDocs.js';

import './css/App.css';

function createDocs(apps){
  return ({match}) => {
    if (match.params.clientId){
      return <MDDocs apps={apps} clientId={match.params.clientId}/>;
    } else {
      return <MDDocs apps={apps} />;
    }
  };
}

function createAppCreator(newAppHandler, notifyHandler){
  return () => (
    <AppCreator newAppHandler={newAppHandler} notifyHandler={notifyHandler}/>
  );
}

function createAppsComponents(
  apps, isAdmin ,removeAppHandler, notifyHandler) {
  return () => (
    <Apps apps={apps}
          isAdmin={isAdmin}
          removeAppHandler={removeAppHandler}
          notifyHandler={notifyHandler}
          />
  );
}

function createNetworkDashBoard(apps, isAdmin){

  let pendingApps = apps.filter(app => app.status === 'Pending Approval');
  
  return ({match}) =>{
    return (
      <Dashboard view="network" apps={apps}
                 isAdmin={isAdmin}
                 date={match.params.date}
                 clientId={match.params.app}
                 pendingApps={pendingApps}
                 networkId={match.params.network}/>
    );
  };
}

function createAppDashBoard(apps, isAdmin){

  let pendingApps = apps.filter(app => app.status === 'Pending Approval');
  
  return function({ match }) {
    return (
      <Dashboard view="app"
                 isAdmin={isAdmin}
                 date={match.params.date}
                 apps={apps}
                 pendingApps={pendingApps}
                 clientId={match.params.app}/>
    );
  };
}

function createMainDashboard(apps, isAdmin){

  let pendingApps = apps.filter(app => app.status === 'Pending Approval');

  
  return function({ match }){
    let date = match.params.date ?
        match.params.date :
        'last+week';

    return (
      <Dashboard
        view="main"
        isAdmin={isAdmin}
        pendingApps={pendingApps}
        date={date}/>
    );
  };
}

const APIIntegration = () => (
  <h1>API Integration</h1>
);


class App extends Component {

  constructor(props){
    super(props);

    this.state = {
      isLoading: true
    };
  }

  notify(msg){

    if (msg.type == 'error'){    
      window.jQuery.notify({
        message:
        `<i class="fa fa-exclamation fa-lg"></i>  ${msg.msg}`
      }, {
        type: 'danger',
        timer: 200
      });
    } else if (msg.type == 'warning') {
      window.jQuery.notify({
        message:
        `<i class="fa fa-warning fa-lg"></i>  ${msg.msg}`
      }, {
        type: 'warning',
        timer: 200
      });      
    } else {
      window.jQuery.notify({
        message:
        `<i class="fa fa-check fa-lg"></i>  ${msg.msg}`
      }, {
        type: 'success',
        timer: 200
      });     
    }
  }
  
  componentWillMount(){
    fetch("/ajax/getUser.php",{
      credentials: "same-origin"
    })
      .then(rsp => rsp.json())
      .then(json => {

        if (json.status == 'success'){
          json.isLoading = false;
          this.setState(json);
        } else {
          window.location = '/login.php';
        }
      }).catch(e => {
        //TODO: fix ui
        console.log(e);
      });
  }
  
  addNewApp(newApp) {

    // send to server
    var request = new Request(
      "/ajax/addApp.php",{
        method: 'POST',
        credentials: "same-origin",
        body: JSON.stringify(newApp), 
        headers: new Headers()
      });

    let newAppItem = {
      name: newApp.name,
      package: newApp.package,
      clientId: 'Loading...',
      status: 'Pending Approval',
      framework: newApp.framework
    };

    fetch(request)
      .then(rsp => rsp.json())
      .then(json => {

        this.notify({
          type: 'success',
          msg: `Successfully Added ${newApp.name}`
        });
        
        this.notify({
          type: 'warning',
          msg: 'New App Must Be Approved Before use'
        });

        newAppItem.clientId = json.clientId;

        this.setState(prevState => {
          let apps = prevState.apps.slice(0);

          apps.push(newAppItem);

          return {
            apps: apps,
            redirect: `/docs/${newAppItem.clientId}`
          };
        });
      }).catch(e => {
        //TODO: fix ui
        console.log(e);
      });;
  }


  componentDidMount(){
    if (this.state.redirect){
      this.setState({
        redirect: false
      });
    }
  }
  
  removeApp(idx){

    let app = this.state.apps[idx];
    
    if (window.confirm(`Delete ${app.name}?`)) {

      // send to server
      var request = new Request(
        "/ajax/deleteApp.php",{
          method: 'POST',
          credentials: "same-origin",
          body: JSON.stringify({
            id: app.id
          }), 
          headers: new Headers()
        });

      fetch(request)
        .then(rsp => rsp.text())
        .then(rspText => console.log(rspText));
      
      this.setState(prevState => {
        prevState.apps[idx].status = 'Awaiting Removal';
        return prevState;
      });
    }

  }
  
  render() {

    return (
      <div className="wrapper">
        {this.state.isLoading && (
          <div id="loading">AppBid Is Loading...</div>
        )}

      {!this.state.isLoading && (
        <Router>
          <Route render={({ location }) => (
            <div id="page-body" className="wrapper">
              <SideBar></SideBar>
              <div className="main-content">
                <TopBar user={this.state.user} apps={this.state.apps}></TopBar>
                <div className="content">
                  <div className="container-fluid">

                    {this.state.redirect &&
                    <Redirect to={this.state.redirect}/>}
                    
                    <CSSTransitionGroup
                      transitionName="fader"
                      transitionEnterTimeout={300}
                      transitionLeaveTimeout={10}
                      >
                      <Switch key={location.key} location={location}>
                        <Route
                          path="/"
                          exact={true}
                          component={createMainDashboard(this.state.apps, this.state.isAdmin)}
                          />
                        <Route
                          path="/dashboard"
                          exact={true}
                          component={createMainDashboard(this.state.apps, this.state.isAdmin)}
                          />
                        <Route
                          path="/dashboard/:date"
                          exact={true}
                          component={createMainDashboard(this.state.apps, this.state.isAdmin)}
                          />
                        <Route
                          path="/dashboard/:date/:app"
                          exact={true}
                          component={
                            createAppDashBoard(
                              this.state.apps, this.state.isAdmin)
                          }
                          />
                        <Route
                          path="/dashboard/:date/:app/:network"
                          component={
                            createNetworkDashBoard(
                              this.state.apps, this.state.isAdmin)
                          }
                          />
                        <Route
                          path="/apps"
                          exact={true}
                          component=
                          {createAppsComponents(
                            this.state.apps,
                            this.state.isAdmin,
                            this.removeApp.bind(this),
                          this.notify.bind(this))}
                          />
                        <Route
                          path="/apps/create"
                          component=
                          {createAppCreator(this.addNewApp.bind(this), this.notify.bind(this))}
                          />

                        <Route
                          path="/billing"
                          exact={true}
                          component={Billing}
                          />

                        
                        <Route
                          path="/docs"
                          exact={true}
                          component={createDocs(this.state.apps)}
                          />
                        
                        <Route
                          path="/docs/:clientId"
                          exact={true}
                          component={createDocs(this.state.apps)}
                          />

                      </Switch>
                    </CSSTransitionGroup>
                  </div>
                </div>
              </div>
            </div>)}/>
          </Router>)}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js